import { User } from "core/models";
import AmountToPayStore from "core/stores/amount-to-pay.store";
import MahPaymentButton from "./mah-payment-button";
import SaPaymentButton from "./sa-payment-button";

type PaymentButtonProps = {
    store: AmountToPayStore;
    user: User | undefined;
    clearPayments: any;
}

const PaymentButton = (props: PaymentButtonProps) => {
    const { store, user, clearPayments } = props;

    if (!store.hasAmountToPayBeenSet || !user) {
        return null;
    }

    return user.isSouthAfricanCustomer
        ? <SaPaymentButton onClear={clearPayments} />
        : <MahPaymentButton onClear={clearPayments} />
}

export default PaymentButton;
